import { useContext } from 'react';
import { useGetSubscriptions } from 'api/subscription';
import { UserContext } from 'context-providers/user-provider';
import { ProductsContext } from 'context-providers/products-provider';
import {
  canSubscriptionEnrollInSRP,
  SRP_SAVINGS_CURRENCY,
  SRP_SAVINGS_USD,
} from 'lib/srp';
import { formatMoneyWholeAware } from 'lib/utils/format-money';

// Drives the SRP upgrade site banner: a member with a monthly DS-01 plan sees
// an upgrade prompt in place of the co-biotics banner. DS-01 enrollment isn't
// country-gated, so this isn't either.
export const useSrpUpgradeBanner = () => {
  const { userState } = useContext(UserContext);
  const { currencyCode } = useContext(ProductsContext);
  const { data: subscriptions, isPending } = useGetSubscriptions();

  // The query is disabled while logged out and so never leaves the pending
  // state; only a member is genuinely waiting on eligibility.
  const isEligibilityPending = Boolean(userState?.email) && isPending;

  const showSrpUpgradeBanner =
    !isEligibilityPending &&
    Boolean(subscriptions?.some((sub) => canSubscriptionEnrollInSRP(sub)));

  // The offer is USD-denominated, so non-USD markets see it labeled as USD
  // rather than converted.
  const usdAmount = formatMoneyWholeAware(
    SRP_SAVINGS_USD,
    SRP_SAVINGS_CURRENCY,
  );
  const srpSavingsLabel =
    currencyCode !== SRP_SAVINGS_CURRENCY
      ? `${SRP_SAVINGS_CURRENCY} ${usdAmount}`
      : usdAmount;

  return { showSrpUpgradeBanner, srpSavingsLabel, isEligibilityPending };
};
